import React from 'react';
import { usePreCallIntel } from './hooks/usePreCallIntel';
import { PreCallHeader } from './components/PreCallHeader';
import { ConnectedCalendars } from './components/ConnectedCalendars';
import { EventsList } from './components/EventsList';
import { BriefingDossier } from './components/BriefingDossier';
import './PreCallIntel.css';

export function PreCallIntel() {
  const {
    navigate,
    connections,
    loadingConns,
    events,
    displayedEvents,
    loadingEvents,
    briefingDetail,
    briefingEventId,
    loadingBriefing,
    isCrmConnected,
    connectedCrmName,
    isSyncing,
    selectedEventId,
    setSelectedEventId,
    activeTab,
    setActiveTab,
    handleSyncNow,
    handleViewIntelligence,
    handleRegenerateIntelligence
  } = usePreCallIntel();

  return (
    <div style={{
      width: '100%',
      margin: '0 auto',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '16px',
      overflow: 'hidden',
      backgroundColor: 'var(--admin-bg)'
    }}>
      <PreCallHeader onSync={handleSyncNow} isSyncing={isSyncing} />

      <div style={{
        flex: 1,
        display: 'grid',
        gridTemplateColumns: '280px 1fr',
        gap: '16px',
        minHeight: 0
      }}>
        {/* Left Sidebar */}
        <div id="tour-precall-calendars" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          minHeight: 0
        }}>
          <ConnectedCalendars 
            connections={connections} 
            loadingConns={loadingConns} 
            onManageClick={() => navigate('/admin/integrations')}
          />

          <EventsList 
            events={displayedEvents} 
            loadingEvents={loadingEvents} 
            selectedEventId={selectedEventId}
            onSelectEvent={setSelectedEventId}
          />
        </div>

        {/* Right Side: Selected Meeting Briefing Dossier */}
        <div id="tour-precall-dossier" style={{ minHeight: 0, display: 'flex', flexDirection: 'column', height: '100%' }}>
          <BriefingDossier 
            selectedEventId={selectedEventId}
            briefingEventId={briefingEventId}
            loadingBriefing={loadingBriefing}
            briefingDetail={briefingDetail}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            isCrmConnected={isCrmConnected}
            connectedCrmName={connectedCrmName}
            onViewIntelligence={handleViewIntelligence}
            onRegenerateIntelligence={handleRegenerateIntelligence}
          />
        </div>
      </div>
    </div>
  );
}
